(() => {
 const init=root=>root.querySelectorAll('[data-lr-journey]').forEach(journey=>{
  if(journey.dataset.ready)return;journey.dataset.ready='true';
  const range=journey.querySelector('[data-journey-range]');
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const states=['Week 0 - Weight focused on lower back','Week 1 - Spine realigned and weight distributed throughout body','Week 2 - Improved blood flow and muscle stress reduced','Week 4 - Corrected posture without the belt - weight is evenly distributed through the body'];
  const buttons=[...journey.querySelectorAll('[data-journey-index]')];
  const bones=[...journey.querySelectorAll('[data-spine]')];
  let value=0,frame=0,played=false,manual=false,visible=false;
  range.step='0.01';
  const update=next=>{
   value=Math.max(0,Math.min(3,next));
   const index=Math.round(value),alignment=Math.min(1,value);
   range.value=value;range.setAttribute('aria-valuetext',states[index]);journey.dataset.stage=index;
   journey.querySelector('[data-journey-state]').textContent=states[index];
   buttons.forEach(b=>{if(Number(b.dataset.journeyIndex)===index)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');});
   journey.style.setProperty('--journey-progress',value/3);
   journey.style.setProperty('--journey-fill',(value/3*100)+'%');
   journey.querySelector('.lrj-posture').style.transform='rotate('+(-6*(1-alignment))+'deg)';
   bones.forEach((b,i)=>b.style.transform='translateX('+(Math.sin(i*.56)*14*(1-alignment))+'px)');
  };
  const stop=()=>{cancelAnimationFrame(frame);frame=0;};
  const manualStart=()=>{manual=true;stop();};
  const animateTo=(target,duration)=>{
   stop();const start=value,begin=performance.now();
   const tick=now=>{
    if(!journey.isConnected)return;
    const t=Math.min(1,(now-begin)/duration),e=t*t*(3-2*t);
    update(start+(target-start)*e);
    if(t<1)frame=requestAnimationFrame(tick);else frame=0;
   };
   frame=requestAnimationFrame(tick);
  };
  range.addEventListener('pointerdown',manualStart);
  range.addEventListener('keydown',manualStart);
  range.addEventListener('input',()=>{manualStart();update(Number(range.value));});
  const settle=()=>{if(!manual)return;const target=Math.round(value);if(motion.matches)update(target);else animateTo(target,480);};
  range.addEventListener('change',settle);
  range.addEventListener('pointerup',settle);
  range.addEventListener('pointercancel',settle);
  range.addEventListener('keyup',settle);
  buttons.forEach(b=>b.addEventListener('click',()=>{manualStart();const target=Number(b.dataset.journeyIndex);if(motion.matches)update(target);else animateTo(target,650);}));
  const play=()=>{
   played=true;const begin=performance.now();
   const tick=now=>{
    if(manual||!visible||document.hidden||!journey.isConnected||motion.matches){stop();return;}
    const elapsed=now-begin;
    // Hold each stage briefly, then ease the entire illustration back to its start.
    let next;
    if(elapsed<600)next=0;
    else if(elapsed<4800)next=(elapsed-600)/1400;
    else if(elapsed<6000)next=3;
    else {const t=Math.min(1,(elapsed-6000)/1800);next=3*(1-t*t*(3-2*t));}
    update(next);
    if(elapsed<7800)frame=requestAnimationFrame(tick);else frame=0;
   };
   frame=requestAnimationFrame(tick);
  };
  const observer=new IntersectionObserver(([entry])=>{
   visible=entry.isIntersecting;
   if(visible&&!played&&!manual&&!motion.matches)play();
   else if(!visible&&!manual){stop();update(0);}
  },{threshold:.35});
  observer.observe(journey);
  motion.addEventListener('change',()=>{stop();if(motion.matches&&!manual)update(0);});
  document.addEventListener('visibilitychange',()=>{if(document.hidden&&!manual){stop();update(0);}});
  update(0);
 });
 init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();
